import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { authService } from "../../services/auth.service";
import Cookies from "js-cookie";
import authType from "./authTypes";
import axios from "../../plugins/axios.plugin";
// import {
//   persistLastLogin,
//   updatePersistedLastLogin,
//   retrievePersistedLastLogin,
//   destroyLastLogin,
// } from "../../helpers/session";

// const storeLoginDetails = (payload) => {
//   return {
//     type: authType["STORE_LOGIN_DETAILS"],
//     payload,
//   };
// };
// const storeUserDetails = (payload) => {
//   return {
//     type: authType["AUTH_SUCCESS"],
//     payload,
//   };
// };

let base_url = window.location.origin;

export const saveUserDetails = (data) => {
  console.log('data', data);
  const user = JSON.stringify(data.data);
  const token = data.data.access_token;
  Cookies.set("token", token);
  
  try {
    localStorage.setItem("user", user);
  } catch (error) {
    console.error("Error saving user data to localStorage:", error);
    // Fallback to cookies if localStorage fails (though this shouldn't happen with the size issue)
    console.warn("Falling back to cookies for user data storage");
    Cookies.set("user", user);
  }
  
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  let team = Object.keys(data?.data?.team_roles);
  if (team) {
    function getHighestPriorityRole(roles) {
      if (roles.includes("administrator")) {
        return "administrator";
      } else if (roles.length > 0) {
        return roles[0];
      }
    }

    axios.defaults.headers.common["Team"] = getHighestPriorityRole(team);
    Cookies.set("team", getHighestPriorityRole(team));
  }
};

/**
 * Register a user
 * 
 * @param {object} payLoad {
    name:"black"
    email:"black@gmail.com"
    password:"password"
    password_confirmation:"password"
    phone:"08021415578"
    description:"I am a human being"
    birth_date:"0000-04-17"
    birth_year:"1997"
  }
 * @returns {void}
 */

export const registerUserAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["REGISTERING_AUTH"], payLoad: true });
    const response = await authService.emailRegistration({ ...payLoad });
    dispatch({ type: authType["REGISTERING_AUTH"], payLoad: false });
    dispatch({ type: authType["REGISTER_USER"], payLoad: response });
    if (response?.status === "success") {
      let loggedIn = await dispatch(
        registerLoginAction({
          email: payLoad?.email,
          password: payLoad?.password,
        })
      );
      loggedIn && successHandler(response, true);
    }
    return response;
  } catch (error) {
    dispatch({ type: authType["REGISTERING_AUTH"], payLoad: false });
    errorHandler(error, true);
    throw error;
  }
};

/**
 * Login a user
 *
 * @param {object} payLoad {
 * "email": "blue@gmail.com",
 * "password": "blueblue"
 * }
 * @returns {void}
 */
export const loginUserAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING_AUTH"], payLoad: true });
    const response = await authService.emailLogin({ ...payLoad });
    dispatch({ type: authType["LOADING_AUTH"], payLoad: false });
    console.log('before login saves');
    dispatch({ type: authType["LOGIN_USER"], payLoad: response });
    console.log('after login');
    saveUserDetails(response, dispatch);
    console.log('after save details');
    // persistLastLogin(res);
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING_AUTH"], payLoad: false });
    errorHandler(error, true);
    throw error;
  }
};

/**
 * Login a user
 *
 * @param {object} payLoad {
 * "email": "blue@gmail.com",
 * "password": "blueblue"
 * }
 * @returns {void}
 */
export const registerLoginAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING_AUTH"], payLoad: true });
    const response = await authService.emailLogin({ ...payLoad });
    dispatch({ type: authType["LOADING_AUTH"], payLoad: false });
    dispatch({ type: authType["LOGIN_USER"], payLoad: response });
    saveUserDetails(response, dispatch);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING_AUTH"], payLoad: false });
    throw error;
  }
};

/**
 * indicate forgot password
 *
 * @param {object} payLoad {email:"",reset_form_link:""}
 * @returns
 */
export const forgotPasswordAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING"], payLoad: true });
    const response = await authService.forgotPassword({
      ...payLoad,
      reset_form_link: `${base_url}/reset-link`,
    });

    dispatch({ type: authType["FORGOT_PASSWORD"], payLoad: response });
    dispatch({ type: authType["LOADING"], payLoad: false });
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Reset a user password
 * 
 * @param {object} payLoad {
  email:"blue@gmail.com"
  token:"lQf5xwqSmxSIyT22OVfe"
  new_password:"this-is-a-new-password"
  new_password_confirmation:"this-is-a-new-password"
 }
 * @returns 
 */
export const resetPasswordAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING"], payLoad: true });
    const response = await authService.resetPassword({
      ...payLoad,
    });
    dispatch({ type: authType["LOADING"], payLoad: false });
    dispatch({ type: authType["RESET_PASSWORD"], payLoad: response });
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Change a user password
 * 
 * @param {object} payLoad {
  old_password:"blue-blue"
  new_password:"black-blue"
  new_password_confirmation:"black-blue"
 }
 * @returns 
 */

export const changePasswordAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING"], payLoad: true });
    const response = await authService.changePassword({
      ...payLoad,
    });
    dispatch({ type: authType["LOADING"], payLoad: false });
    dispatch({ type: authType["CHANGE_PASSWORD"], payLoad: response });
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const toggleLoginModal = (payLoad) => async (dispatch) => {
  dispatch({ type: authType["TOGGLE_LOGIN_MODAL"], payLoad: payLoad });
};

/**
 * Allow Login Provider
 * 
 * @param {object} payLoad {
  provider_name:"google"|"apple"|"linkedin"|"facebook"
  user_id:"your-user-id"
 }
 * @returns 
 */

export const allowLoginProvider = (payLoad) => async (dispatch) => {
  try {
    const response = await authService.allowLoginProvider({
      ...payLoad,
    });
    dispatch({ type: authType["LOADING"], payLoad: false });
    // dispatch({ type: authType["CHANGE_PASSWORD"], payLoad: response });
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Disallow Login Provider
 * 
 * @param {object} payLoad {
  provider_name:"google"|"apple"|"linkedin"|"facebook"
  user_id:"your-user-id"
 }
 * @returns 
 */

export const disallowLoginProvider = (payLoad) => async (dispatch) => {
  try {
    const response = await authService.disallowLoginProvider({
      ...payLoad,
    });
    dispatch({ type: authType["LOADING"], payLoad: false });
    successHandler(response, true);
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const getUserAuthDetails = () => async (dispatch) => {
  try {
    dispatch({ type: authType["LOADING"], payLoad: true });
    const response = await authService.myAuthDetails();
    dispatch({ type: authType["LOADING"], payLoad: false });
    dispatch({ type: authType["USER_DETAILS"], payLoad: response });
    return true;
  } catch (error) {
    dispatch({ type: authType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Test user model
 *
 * @param {void}
 * @returns
 */
// export const testUserModelAction = () => {
//   return (dispatch) => {
//     dispatch({ type: LOADING, payLoad: true });
//     Axios.get(`auth/test`)
//       .then((res) => {
//         dispatch({ type: LOADING, payLoad: false });
//         dispatch({ type: TEST_USER_MODEL, payLoad: res });
//         successHandler(res, true);
//       })
//       .catch((error) => {
//         dispatch({ type: LOADING, payLoad: false });
//         errorHandler(error, true);
//       });
//   };
// };
